import type { FaireProductEntity } from "../../entity_types/product";

export const p_k5djrkxge7: FaireProductEntity = {
  token: "p_k5djrkxge7",
  type: "product",
  name: "Fun Doh Color Changing Dumpling Squishy Toy - 12/Display",
  brandToken: "b_bsd2pg2itm",
  brandName: "Novelty Brands",
  imageUrl:
    "https://cdn.faire.com/fastly/185b6085bb6a6dbd2340c749c2d95789da8ced5106c5edb7770532a9fb55137c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/416d82975d2ae53201f1e8878413288a59ac2fe9802d52a664a9c8ef84c0ddda.png",
    "https://cdn.faire.com/fastly/87deea888807a6a823f139d8218cd50d9e4ded141b4567a0a7caa06ae3f50760.png",
    "https://cdn.faire.com/fastly/8a39833b8a225c34c9913a8702ac044fc0e72cbfd83db2b067557d559b5427a9.png",
    "https://cdn.faire.com/fastly/eb413709751b7cdb28e979eeb3209704326cebf56f6edb8f419f407b6f5023ae.png",
  ],
  priceDollars: 6,
  description:
    "Capture the attention of shoppers of all ages with the Fun Doh Squishy Color Changing Dumpling Toy. This captivating novelty item brings a magical twist to the classic fidget toy. Not only does it offer an incredibly soft, satisfying, and stress-relieving squeeze, but it also features dual color-shifting properties: it dramatically changes hues when exposed to sunlight and brilliantly glows under blacklight.\n\nWhy Retailers Love It\nEye-Catching Retail Display: Shipped in a vibrant, retail-ready 12-piece countertop display box designed to maximize impulse buys at your cash wrap.\n\nTrending Novelty Appeal: Capitalizes on the massive, ongoing popularity of sensory fidget toys and viral novelty trends.\n\nBroad Customer Base: Perfectly suited for gift shops, toy stores, boutique checkout counters, and sensory wellness displays.\n\nKey Features\nMagical Color Transition: Shifts colors seamlessly in natural sunlight and reacts dynamically under blacklights.\n\nPremium Sensory Texture: Ultra-soft, pliable, and durable material designed to withstand endless squeezing and stretching.\n\nPerfect Impulse Gift: An affordable, high-delight item that makes a great party favor, stocking stuffer, or reward.\n\nWHOLESALE BULK ITEM",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:51:39.515Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
